<template>
    <div class="context"
         v-loading="show_view_loading"
         :element-loading-text="loading_text"
         element-loading-spinner="el-icon-warning"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <div class="form">
                <el-form :model="auditForm"
                         size="small"
                         ref="patient_form"
                         label-width="120px"
                         :disabled="disabled"
                         :rules="patientRules">
                    <div class="msg_title">基本信息：</div>
                    <el-form-item class="no_bottom" label="姓名">
                        <el-input v-model="auditForm.name"
                                  class="width_220"></el-input>
                    </el-form-item>
                    <el-form-item class="no_bottom" label="性别">
                        <el-radio-group v-model="auditForm.sex">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="2">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item class="no_bottom" label="手机号">
                        <div>{{auditForm.phone}}</div>
                    </el-form-item>
                    <el-form-item class="no_bottom" label="省/市">
                        <el-cascader
                                class="width_220"
                                placeholder="请选择省市"
                                clearable
                                v-model="auditForm.provinceAndCity"
                                :options="city_list"
                                :props="cascader_props"
                                @clear="cityClear"
                                @change="getHospital()">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item class="no_bottom" label="就诊医院">
                        <el-autocomplete
                                @clear="hospitalClear"
                                clearable
                                class="inline-input"
                                v-model="auditForm.hospital"
                                :fetch-suggestions="querySearch"
                                value-key="name"
                                placeholder="请输入医院名称"
                                @select="handleSelect"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item class="no_bottom" label="医生" prop="doctor_id" :inline-message="true">
                        <el-select v-model="auditForm.doctor_name" filterable @change="doctorChange"
                                   @clear="doctorClear" placeholder="请选择医生" clearable>
                            <el-option
                                    v-for="item in doctorList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="no_bottom" label="注册时间">
                        <el-date-picker
                                v-model="auditForm.create_time"
                                type="datetime"
                                placeholder="选择注册时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="no_bottom" v-if="disabled" label="状态">
                        <div>
                            {{auditForm.status | showStatus}}
                        </div>
                    </el-form-item>

                    <div class="msg_title warning_msg"
                         v-if="!auditForm.first_drug_date && !disabled">
                        请验证基因检测报告信息
                    </div>
                    <div class="msg_title" v-if="auditForm.first_drug_date">用药信息：</div>

                    <div v-if="auditForm.first_drug_date">
                        <el-form-item label="使用药物" prop="drug_code">
                            <div class="compare_box">
                                <el-select class="width_220"
                                           @change="drugChange"
                                           v-model="auditForm.drug_code">
                                    <el-option v-for="(item ,index) in drug_code_list"
                                               :label="item.product_name"
                                               :value="item.drug_code"
                                               :key="index"
                                    ></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item class="no_bottom" label="癌种">
                            <el-select
                                    v-model="auditForm.tumour_id"
                                    class="width_220"
                                    placeholder="请选择癌种"
                            >
                                <!--@change="getCalcStage"-->
                                <el-option
                                        v-for="(item, index) in allIllData"
                                        :label="item.name"
                                        :value="item.tumour_id"
                                        :key="index"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="getUniteDrug_product_type(auditForm.drug_code)&&has_count(auditForm.drug_code)"
                                      prop="medication_count"
                                      label="支数">
                            <div class="compare_box">
                                <el-input-number v-model="auditForm.medication_count"
                                                 controls-position="right"
                                                 @change="get_next_time"
                                                 :min="0"></el-input-number>
                            </div>
                        </el-form-item>
                        <div v-else-if="has_count(auditForm.drug_code)">
                            <el-form-item label="支数(9mg)" prop="medication_count">
                                <div class="compare_box">
                                    <el-input-number v-model="auditForm.sub_count1"
                                                     controls-position="right"
                                                     @change="changeNumber"
                                                     :min="0"></el-input-number>
                                </div>
                            </el-form-item>
                            <el-form-item label="支数(4.5mg)" prop="medication_count">
                                <div class="compare_box">
                                    <el-input-number v-model="auditForm.sub_count2"
                                                     controls-position="right"
                                                     @change="changeNumber"
                                                     :min="0"></el-input-number>
                                </div>
                            </el-form-item>
                        </div>

                        <el-form-item v-if="has_count(auditForm.drug_code)"
                                      prop="medication_type"
                                      label="类别">
                            <el-select v-model="auditForm.medication_type" class="width_220">
                                <el-option v-for="(item, index) in drug_type_list"
                                           :label="item"
                                           :value="item"
                                           :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="no_bottom" label="首次用药时间">
                            <el-date-picker
                                    v-model="auditForm.first_drug_date"
                                    type="date"
                                    @change="get_next_time"
                                    :picker-options="picker_option"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class="no_bottom" label="本次用药时间">
                            <el-date-picker
                                    v-model="auditForm.first_drug_date2"
                                    type="date"
                                    @change="get_next_time"
                                    :picker-options="picker_option_now_drug_time"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>


                        <el-form-item label="默认周期天数" prop="">
                            <el-input-number v-model="auditForm.medication_cycle_days"
                                             controls-position="right"
                                             @change="get_next_time"
                                             :min="0"></el-input-number>
                        </el-form-item>
                        <el-form-item label="当前用药周期" prop="">
                            <span style="padding-right: 5px">Cycle</span>
                            <span>
                                <el-input-number v-model="auditForm.medication_cycle"
                                                 controls-position="right"
                                                 :min="1"></el-input-number>
                            </span>
                        </el-form-item>
                        <el-form-item label="下次购药日期" prop="">
                            <el-date-picker
                                    v-model="auditForm.next_medication_date"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <!--
                        <el-form-item class="no_bottom" label="联合使用药物">
                            <el-select v-model="auditForm.drug_code_list"
                                       multiple
                                       :multiple-limit="2"
                                       placeholder="请选择药物">
                                <el-option
                                        v-for="item in uniteDrugList"
                                        :key="item.drug_code"
                                        :label="item.product_name"
                                        :value="item.drug_code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        -->
                        <el-form-item>
                            <el-button type="primary"
                                       :disabled="disabled"
                                       @click="add_unite_drug()"
                                       plain>添加联合使用药物+</el-button>
                            <span class="unite_msg" v-if="show_unite_msg">请完善使用药物</span>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="unite_item"
                     v-for="(form, index) in unite_drug_code_list"
                     :key="index">
                    <span class="unite_title">联合使用药物{{index + 1}}</span>
                    <span class="table_del_btn" @click="delUnite(index)">删除</span>
                    <el-form :model="form"
                             label-width="100px"
                             :disabled="disabled"
                             ref="uniteForm"
                             size="small">
                        <el-form-item label="使用药物"
                                      prop="drug_code">
                            <el-select class="width_220"
                                       @change="e => uniteDrugChange(e, index)"
                                       v-model="form.drug_code">
                                <el-option v-for="(item ,index) in uniteDrugList"
                                           :label="item.product_name"
                                           :value="item.drug_code"
                                           :key="index"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="getUniteDrug_product_type(form.drug_code)"
                                      prop="medication_count"
                                      label="支数">
                            <div class="compare_box">
                                <el-input-number v-model="form.medication_count"
                                                 controls-position="right"
                                                 :min="0"></el-input-number>
                            </div>
                        </el-form-item>
                        <div v-else>
                            <el-form-item label="支数(9mg)"
                                          prop="medication_count">
                                <div class="compare_box">
                                    <el-input-number v-model="form.sub_count1"
                                                     controls-position="right"
                                                     @change="changeCount_list(index)"
                                                     :min="0"></el-input-number>
                                </div>
                            </el-form-item>
                            <el-form-item label="支数(4.5mg)"
                                          prop="medication_count">
                                <div class="compare_box">
                                    <el-input-number v-model="form.sub_count2"
                                                     controls-position="right"
                                                     @change="changeCount_list(index)"
                                                     :min="0"></el-input-number>
                                </div>
                            </el-form-item>
                        </div>

                        <el-form-item prop="medication_type"
                                      label="类别">
                            <el-select v-model="form.medication_type" class="width_220">
                                <el-option v-for="(item, index) in getUniteDrugType(form.drug_code)"
                                           :label="item"
                                           :value="item"
                                           :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <el-form v-if="auditForm.first_drug_date"
                         :model="auditForm"
                         ref="bill_form"
                         size="small"
                         label-width="100px"
                         :disabled="disabled"
                         :rules="rules">
                    <div class="msg_title">用药发票：</div>
                    <el-form-item label="发票代码" prop="invoice_ocr_data.invoice_code">
                        <div class="compare_box">
                            <el-input v-model="auditForm.invoice_ocr_data.invoice_code"
                                      class="width_220"></el-input>
                            <span class="right_text">{{billForm.invoice_code}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="发票号码" prop="invoice_ocr_data.invoice_no">
                        <div class="compare_box">
                            <el-input v-model="auditForm.invoice_ocr_data.invoice_no"
                                      class="width_220"></el-input>
                            <span class="right_text">{{billForm.invoice_no}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="购买人" prop="invoice_ocr_data.buyer">
                        <div class="compare_box">
                            <el-input v-model="auditForm.invoice_ocr_data.buyer"
                                      class="width_220"></el-input>
                            <span class="right_text">{{billForm.buyer}}</span>
                        </div>
                    </el-form-item>
                </el-form>

                <div class="btn_box">
                    <el-button @click="submit_audit"
                               v-if="!disabled && powerAudit"
                               size="small"
                               type="primary">通过
                    </el-button>
                    <el-button @click="dialogTableVisible = true"
                               v-if="!disabled && powerRefuse"
                               size="small"
                               type="danger">拒绝
                    </el-button>
                    <el-button @click="submit_delete"
                               size="small"
                               v-if="powerDel"
                               type="danger">删除
                    </el-button>
                    <el-button @click="nextRow" size="small">下一个</el-button>
                </div>
            </div>
            <div class="image_form">
                <div class="msg_title">发票图片</div>
                <div class="img_box">
                    <!--<img-view :imgUrl="auditForm.invoice_path_url"></img-view>-->
<!---->
                    <el-carousel v-if="auditForm.invoice_path_url && auditForm.invoice_path_url.length > 0"
                                 trigger="click"
                                 :autoplay="false"
                                 width="100%"
                                 style="width: 100%;height: 100%"
                                 height="100%">
                        <el-carousel-item v-for="item in auditForm.invoice_path_url" :key="item">
                            <img-view :imgUrl="item"></img-view>
                        </el-carousel-item>
                    </el-carousel>
                </div>

            </div>
        </div>

        <el-dialog
                title="拒绝理由"
                :visible.sync="dialogTableVisible"
                :modal-append-to-body="false"
        >
            <el-table :data="tableData" @current-change="handleCurrentChange">
                <el-table-column width="50">
                    <input type="checkbox" name="" id="" slot-scope="scope" v-model="scope.row.checked">
                </el-table-column>
                <el-table-column prop="reason" label="拒绝理由">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;">
                            <template v-if="scope.row.id == 8">
                                {{scope.row.reason}}
                                <el-input v-model="scope.row.value" :disabled="!scope.row.checked" placeholder="请输入拒绝理由"
                                          style="width: 80%;"></el-input>
                            </template>
                            <template v-else>{{scope.row.reason}}</template>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit_refuse">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import {clone, lcGet} from "@/global/utils";
    import {getImageUrl} from "@/api/index";
    import imgView from "../common/imgView";

    import {calc_times, calc_times_2} from "../../global/calc_drug"

    export default {
        name: "auditView",
        components: {
            imgView
        },
        data() {
            const code_check = (rule, value, callback) => {
                console.log(value, '401');
                if (!value || value == 0) {
                    callback(new Error('请输入支数'))
                }
                callback()
            };
            return {
                auditForm: {
                    invoice_ocr_data: {
                        drug_code: null
                    }
                },
                billForm: {},
                rules: {
                    'invoice_ocr_data.invoice_code': [{required: true, message: '请输入发票代码', trigger: 'blur'}],
                    'invoice_ocr_data.invoice_no': [{required: true, message: '请输入发票号码', trigger: 'blur'}],
                    'invoice_ocr_data.buyer': [{required: true, message: '请输入购买人', trigger: 'blur'}],
                },
                patientRules: {
                    'drug_code': [{
                        required: true,
                        message: '请选择药品名称',
                        trigger: 'blur',
                        type: 'number',
                    }],
                    'medication_type': [{
                        required: true,
                        message: '请选择类别',
                        trigger: 'blur'
                    }],
                    'doctor_id': [{
                        required: true,
                        message: '请选择医生',
                        trigger: 'blur'
                    }],
                    'medication_count': [{
                        required: true,
                        validator: code_check, trigger: 'blur'
                    }],
                },
                viewTitle: '审核',
                disabled: false,

                unite_drug_code_list: [],
                show_unite_msg: false,
                carousel_height: 800,

                type_list: [],
                picker_option: {
                    disabledDate: function (time) {
                        return time.getTime() > new Date().getTime()
                    }
                },

                dialogTableVisible: false,
                currentRow: null,
                tableData: [
                    {
                        id: 1,
                        checked: false,
                        reason: "发票图片无法识别，请重新拍照上传",
                    },
                    {
                        id: 2,
                        checked: false,
                        reason: "发票号码查验有误，请提供正确的发票",
                    },
                    {
                        id: 3,
                        checked: false,
                        reason: "发票日期不符合标准，请提供日期为2022年1月1日以后的发票",
                    },
                    {
                        id: 4,
                        checked: false,
                        reason:
                            "发票名称与注册用户姓名不一致，请提供与注册用户姓名一致的发票",
                    },
                    {
                        id: 5,
                        checked: false,
                        // reason: "发票内容未含达伯舒（信迪利单抗注射液），请提供正确的发票",
                        reason: "发票内容未含药品信息，请提供正确的发票",
                    },
                    {
                        id: 6,
                        checked: false,
                        reason: "此发票重复提交，请更换发票",
                    },
                    {
                        id: 7,
                        checked: false,
                        reason: "该用户和手机号已被注册，不能重复注册",
                    },
                    {
                        id: 9,
                        checked: false,
                        reason: "基因检测报告验证未通过，请重新上传",
                    },
                    {
                        id: 8,
                        checked: false,
                        value: '',
                        reason: "其他（请备注）",
                    },
                ],
                cascader_props: {
                    expandTrigger: 'hover',
                    value: 'name',
                    label: 'name',
                    children: 'city_list',
                },
                hospitalList: [],
                doctorList: [],

                // 锁定参数
                lock_time: 200,
                time_inter: null,
                show_view_loading: false,
                is_lock: false,
                is_requesting: false,


                // 配置项
                drug_type_list: [],
                cycle_days: 21,
                cycle_medication_count: 2,
                cycle_type: 'count',
                // medication_cycle_days_conf: {},

                drug_code_list: [],
                select_drug_conf: {}
            }
        },
        computed: {
            ...mapState('illuserData', {
                audit_ill_id: 'audit_ill_id',
                audit_ill_ids: 'audit_ill_ids'
            }),
            ...mapState("comInformationData", {
                city_list: "city_list",
                authority: 'authority',
                allIllData: 'allIllData',
                // drug_code_list: 'drug_code_list',
                // medication_fields_conf: 'medication_fields_conf'
            }),

            powerAudit() {
                return this.authority.indexOf('sick-audit-pass') > -1
            },
            powerRefuse() {
                return this.authority.indexOf('sick-audit-refuse') > -1
            },
            powerDel() {
                return this.authority.indexOf('sick-audit-del') > -1
            },

            loading_text() {
                return `还有${this.lock_time}秒将自动解锁！`
            },
            uniteDrugList() {
                // console.log(this.drug_code_list, this.auditForm.drug_code)
                return this.drug_code_list.filter(l => l.drug_code !== this.auditForm.drug_code)
            },
            picker_option_now_drug_time() {
                let now_time = new Date().getTime();
                let time = this.auditForm.first_drug_date || new Date().getTime();
                let first_time = new Date(time).getTime() - 1000 * 3600 * 24;
                let options = {
                    disabledDate: function (time) {
                        return time.getTime() > now_time || time.getTime() < first_time
                    }
                };
                return options
            },
        },
        watch: {},
        filters: {
            showStatus(val) {
                return val == '1' ? '已注册' :
                    val == '2' ? '待审核' :
                        val == '3' ? '已审核' :
                            val == '4' ? '已拒绝' :
                                ''
            }
        },
        mounted() {
            this.getDrugList();
        },
        beforeDestroy() {
            window.removeEventListener('mousemove', this.lockNow);
            if (this.time_inter) {
                clearInterval(this.time_inter);
            }

            if (this.is_lock) {
                this.unlockNow()
            }
        },
        methods: {
            add_unite_drug(code) {
                let item = {
                    drug_code: code ? code : '',
                    medication_count: 0,
                    sub_count1: 0,
                    sub_count2: 0,
                    medication_type: ''
                };
                this.unite_drug_code_list.push(item)
            },
            delUnite(index) {
                console.log(index ,'626');
                this.unite_drug_code_list.splice(index, 1)
            },
            getUniteDrugType(code) {
                if(!code) return [];
                let conf = this.drug_code_list.filter(res => res.drug_code == code)[0];
                return conf ? conf.drug_type_list : []
            },
            getUniteDrug_product_type(code) {
                let product_type = 1; // 1单规格  2多规格
                if(code) {
                    let conf = this.drug_code_list.filter(res => res.drug_code == code)[0];
                    product_type = conf ? conf.product_type : 1
                }
                // console.log(product_type, '639');
                return !product_type || product_type == 1
            },
            has_count(code) {
                return !(code == 3 || code == 0)
            },
            uniteDrugChange(e, index) {
                this.unite_drug_code_list[index] = {
                    drug_code: e,
                    medication_count: 0,
                    sub_count1: 0,
                    sub_count2: 0,
                    medication_type: ''
                }
            },

            doctorChange(val) {
                let doc = this.doctorList.find(l => l.name == val);
                if (doc) {
                    this.auditForm.doctor_id = doc.user_id;
                }
            },
            doctorClear() {
                this.auditForm.doctor_id = '';
                this.auditForm.doctor_name = '';
            },

            drugChange() {
                this.auditForm.medication_count = 0;
                this.auditForm.sub_count1 = 0;
                this.auditForm.sub_count2 = 0;
                this.auditForm.medication_type = '';

                this.auditForm.next_medication_date = '';
                this.auditForm.medication_cycle = '';
                // if (this.auditForm.drug_code_list.length > 0) {
                //     let index = this.auditForm.drug_code_list.findIndex(l => l == this.auditForm.drug_code);
                //     if (index != -1) {
                //         this.auditForm.drug_code_list.splice(index, 1)
                //     }
                // }
                this.unite_drug_code_list = [];
                this.get_drug_conf()
            },
            changeNumber() {
                this.auditForm.medication_count = Number(this.auditForm.sub_count1) + Number(this.auditForm.sub_count2)
                this.get_next_time()
            },
            changeCount_list(index) {
                let form = this.unite_drug_code_list[index];
                form.medication_count = Number(form.sub_count1)  + Number(form.sub_count2)
                this.$forceUpdate()
            },

            set_form_drug_code() {
                let form_clone = clone(this.auditForm);
                this.auditForm.invoice_ocr_data.drug_code = Number(form_clone.drug_code);
                this.get_drug_conf('first')
            },
            get_drug_conf(type = '') {
                let drug_code = this.auditForm.drug_code;
                let conf = this.drug_code_list.filter(res => res.drug_code === drug_code)[0];
                // console.log(conf, drug_code,this.drug_code_list, '615');
                this.select_drug_conf = conf;

                let names = ['drug_type_list', 'cycle_days', 'cycle_medication_count', 'cycle_type'];
                for (let i = 0; i < names.length; i++) {
                    if (conf[names[i]]) {
                        this[names[i]] = conf[names[i]]
                    }
                }
                this.get_days(type);
            },
            get_days(type) {
                let days = this.cycle_days;
                if (type === 'first' && this.auditForm.medication_cycle_days) {
                } else {
                    this.auditForm.medication_cycle_days = Number(clone(days));
                }

                this.get_next_time()
            },
            get_next_time() {
                let days = this.auditForm.medication_cycle_days;
                let default_count = this.cycle_medication_count;
                let cycle_type = this.cycle_type;
                let count = this.auditForm.medication_count;
                let first_time = this.auditForm.first_drug_date;
                let first_drug_date2 = this.auditForm.first_drug_date2;
                let data = calc_times_2(
                    cycle_type,
                    default_count,
                    count,
                    first_time,
                    days,
                    first_drug_date2);
                if (!data) return;
                // console.log(data, '489');
                this.auditForm.next_medication_date = data.next_medication_date;
                this.auditForm.medication_cycle = data.medication_cycle;
            },


            handleSelect(item) {
                // console.log(item);
                this.auditForm.hospital_id = item.hospital_id;
                this.auditForm.hospital_name = item.name;
                this.getDoctorList(item.hospital_id);
            },
            getDoctorList(hospital_id) {
                let params = {
                    hospital_id: hospital_id
                };
                this.httpGet('/doctor', params).then(res => {
                    this.doctorList = res.data.data_list;
                });
            },
            getHospital() {
                // console.log(this.auditForm.provinceAndCity,this.auditForm.hospital,this.auditForm.hospital_id)
                let params = {
                    province: this.auditForm.provinceAndCity[0] ? this.auditForm.provinceAndCity[0] : '',
                    city: this.auditForm.provinceAndCity[1] ? this.auditForm.provinceAndCity[1] : '',
                };
                this.httpGet('/hospital', params).then(res => {
                    this.hospitalList = res.data.data_list;
                    // console.log(res.data.data_list)
                    // if (res.data.total > 1000) {
                    //     this.$message.warning('医院数据搜索结果已超过1000条！请精确搜索条件')
                    // }
                })
            },
            cityClear() {
                this.hospitalList = [];
                this.doctorList = [];
            },
            hospitalClear() {
                this.doctorList = [];
            },

            getDrugList() {
                this.httpGet('/product/list').then(res => {
                    this.drug_code_list = res.data.data_list;

                    this.getIllForm(this.audit_ill_id);
                });
            },
            back() {
                this.$emit('changeTopTab', 'tableView')
            },
            getIllForm(id) {
                console.log(id, 'getillform---------');
                const that = this;
                this.httpGet(`/user/patient/${id}`).then(res => {
                    // console.log("患者信息", res.data);
                    this.auditForm = res.data;
                    this.auditForm.provinceAndCity = [];
                    if (this.auditForm.province) {
                        this.auditForm.provinceAndCity = [this.auditForm.province, this.auditForm.city]
                    }
                    if (this.auditForm.drug_code_list) {
                        this.auditForm.drug_code_list = JSON.parse(this.auditForm.drug_code_list);
                        let index = this.auditForm.drug_code_list.findIndex(n => n == this.auditForm.drug_code)
                        if (index != -1) {
                            this.auditForm.drug_code_list.splice(index, 1);
                        }

                    } else {
                        this.auditForm.drug_code_list = [];
                    }

                    this.getHospital();
                    this.auditForm.drug_code = Number(this.auditForm.drug_code);
                    if (this.auditForm.hospital_id) {
                        this.getDoctorList(this.auditForm.hospital_id);
                    }
                    // console.log(this.auditForm)
                    this.billForm = clone(this.auditForm.invoice_ocr_data);
                    // 根据患者状态判断是审核还是查看
                    if (this.auditForm.status == 2) {
                        this.viewTitle = '审核';
                        this.disabled = false;
                        //    待审核的进入锁定状态
                        this.lockNow('first');
                    } else {
                        this.viewTitle = '查看';
                        this.disabled = true
                    }
                    // this.getCalcStage();

                    if (res.data.drug_code && res.data.drug_code != 0) {
                        this.set_form_drug_code()
                    }

                    if(this.auditForm.unite_drug_code_list) {
                        this.unite_drug_code_list = this.auditForm.unite_drug_code_list;
                    } else if(this.auditForm.drug_code_list && this.auditForm.drug_code_list.length > 0) {
                        this.auditForm.drug_code_list.forEach(v => {
                            that.add_unite_drug(v)
                        })
                    }

                })
            },
            getCalcStage() {
                if (!this.auditForm.first_drug_date || !this.auditForm.tumour_id) return;
                let params = {
                    first_drug_date: this.auditForm.first_drug_date,
                    tumour_id: this.auditForm.tumour_id
                };
                this.httpGet('/user/patient/check_tumour_stage', params).then(res => {
                    this.$set(this.auditForm, 'tumour_stage', res.data.stage.name);
                    this.$set(this.auditForm, 'tumour_cycle', res.data.cycle.name);
                    this.auditForm.tumour_stage_id = res.data.stage.cycle_id;
                    this.auditForm.tumour_cycle_id = res.data.cycle.cycle_id;
                });

                this.get_days()
            },

            submit_audit() {
                this.auditForm.invoice_ocr_data = {
                    ...this.auditForm.invoice_ocr_data,
                    drug_code: this.auditForm.drug_code,
                    medication_count: this.auditForm.medication_count,
                    sub_count1: this.auditForm.sub_count1,
                    sub_count2: this.auditForm.sub_count2,
                    medication_type: this.auditForm.medication_type
                };
                if (!this.auditForm.first_drug_date) {
                    if (!this.auditForm.invoice_path_url) {
                        this.$message.warning('需要提供购药资料或基因检测报告。');
                        return
                    }
                    let params = {
                        ...this.auditForm,
                    };
                    console.log(params, 'audit------');
                    this.httpPost('/user/patient/audit/success', params).then(res => {
                        this.$message.success('审核成功');
                        setTimeout(() => {
                            this.nextRow()
                        }, 1000)
                    });
                    return
                }
                this.$refs.patient_form.validate(valid => {
                    if (valid) {
                        let unite_list = this.unite_drug_code_list;
                        let unite_valid = true;
                        unite_list.map((v, i) => {
                            if(v.drug_code && v.medication_count && v.medication_type) {
                            } else {
                                unite_valid = false;
                            }
                        });
                        if(unite_valid) {
                            this.auditForm.unite_drug_code_list = this.unite_drug_code_list;
                            this.$refs.bill_form.validate(b_valid => {
                                if (b_valid) {
                                    let params = {
                                        ...this.auditForm,
                                    };
                                    console.log(params, 'audit------');
                                    this.httpPost('/user/patient/audit/success', params).then(res => {
                                        this.$message.success('审核成功');
                                        setTimeout(() => {
                                            this.nextRow()
                                        }, 1000)
                                    })
                                }
                            })
                        } else {
                            this.$message.warning('请完善联合使用药物');
                            this.show_unite_msg = true;
                            setTimeout(() => {
                                this.show_unite_msg = false
                            }, 1000 * 5)
                        }
                    }
                })

            },
            submit_refuse() {
                let list = this.tableData.find(l => l.checked);
                if (!list) {
                    this.$message('请选择拒绝理由');
                    return;
                }
                if (list.id == 8) {
                    if (!list.value) {
                        this.$message({
                            message: '请备注其他理由',
                            type: 'warning'
                        });
                        return
                    }
                }
                let params = {
                    patient_id: this.auditForm.patient_id,
                    reason: list.id == 8 ? list.value : list.reason
                };
                this.httpPost('/user/patient/audit/fail', params).then(res => {
                    this.dialogTableVisible = false;
                    this.$message.success('拒绝成功');
                    setTimeout(() => {
                        this.nextRow()
                    }, 1000)
                })
            },
            submit_delete() {
                this.$confirm('确定删除该患者么？').then(res => {
                    this.httpDel(`/user/patient/${this.auditForm.patient_id}`).then(res => {
                        this.$message.success('删除成功！');
                        setTimeout(() => {
                            this.nextRow('del')
                        }, 1000)
                    })
                })
            },
            nextRow(type) {
                let index_ = -1;
                this.audit_ill_ids.forEach((v, i) => {
                    if (v == this.auditForm.patient_id) {
                        index_ = i
                    }
                });

                if (index_ === this.audit_ill_ids.length - 1) {
                    this.$message.warning('已经是最后一条了');
                    if (type && type === 'del') {
                        this.goBack()
                    } else {
                        this.getIllForm(this.auditForm.patient_id)
                    }

                } else {
                    let id = this.audit_ill_ids[index_ + 1];
                    console.log(this.audit_ill_ids, index_,id, '936');
                    this.getIllForm(id);
                    this.$message.success('已进入下一条');
                }
            },

            handleCurrentChange(val) {
                this.currentRow = val;
                this.tableData.forEach((data, index) => {
                    if (data.id !== val.id) {
                        data.checked = false;
                    } else {
                        data.checked = true;
                    }
                    this.$set(this.tableData, index, data)
                });
                this.$forceUpdate()
            },

            /**
             * 锁定
             * */
            setKeyUp() {
                // 监听操作
                window.addEventListener('mousemove', this.lockNow);
            },
            setLockInter() {
                this.time_inter = setInterval(() => {
                    this.lock_time--;
                    this.show_view_loading = this.lock_time <= 60 && this.lock_time > 0;
                    if (this.lock_time <= 0) {
                        clearInterval(this.time_inter);
                        this.unlockNow();
                        this.$msgbox({
                            title: '警告',
                            message: '该数据已自动解锁，如需锁定请点击锁定！',
                            showCancelButton: true,
                            confirmButtonText: '锁定',
                            cancelButtonText: '下一个',
                        }).then(() => {
                            this.lockNow()
                        }).catch(() => {
                            this.nextRow('del')
                        })
                    }
                }, 1000)
            },
            changeLockTime() {
                /**
                 * 待审核锁定，10分钟后自动解锁
                 * 操作的情况下5分钟重新锁定，重新计算时间
                 * 不操作，9分钟的时候进行提示，还不操作即锁定
                 */
                this.show_view_loading = false;
                this.lock_time = 590;
            },
            lockNow(type) {
                if (this.lock_time > 300) return; // 自动锁定时间不到一半的时候再通过
                if (this.is_requesting) return;
                this.is_requesting = true;
                let params = {
                    user_id: this.auditForm.user_id
                };
                this.httpGet('/user/patient/lock', params).then(res => {
                    // debugger;
                    this.is_requesting = false;
                    if (res.data.success) {
                        this.is_lock = true;
                        this.changeLockTime();
                        if (this.time_inter) {
                            clearInterval(this.time_inter);
                        }
                        this.setLockInter();
                        console.log('锁定成功');

                        if(type === 'first') {
                            this.setKeyUp()
                        }
                    } else {
                        this.$message.warning('该条数据已被其他人锁定！');
                        setTimeout(() => {
                            this.nextRow('del')
                        }, 10)
                    }
                })
            },
            unlockNow() {
                let params = {
                    user_id: this.auditForm.user_id
                };
                this.httpGet('/user/patient/unlock', params).then(res => {
                    this.is_lock = false;
                    this.lock_time = 200;
                    if (this.time_inter) {
                        clearInterval(this.time_inter);
                    }
                    console.log('解锁成功');
                })
            },
            querySearch(queryString, cb) {
                if (queryString) {
                    let params = {
                        name: queryString,
                        province: this.auditForm.provinceAndCity[0] ? this.auditForm.provinceAndCity[0] : '',
                        city: this.auditForm.provinceAndCity[1] ? this.auditForm.provinceAndCity[1] : '',
                    };
                    this.httpGet('/hospital', params).then(res => {
                        cb(res.data.data_list);
                    })
                } else {
                    cb(this.hospitalList);
                }

            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background: #fff;
        .header {
            height: 45px;
            line-height: 45px;

            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            .search {
                padding-top: 15px;
            }
        }
        .main_box {
            display: flex;
            height: calc(100% - 50px);
            overflow: hidden;
            .form {
                flex: 1;
                height: 100%;
                overflow: hidden;
                overflow-y: auto;
                padding: 5px;
                box-sizing: border-box;
                min-width: 400px;
                .btn_box {
                    padding-left: 120px;
                    display: flex;
                    flex-wrap: wrap;
                    .el-button {
                        margin-bottom: 5px;
                    }
                }
                .msg_title {
                    line-height: 35px;
                    font-size: .875rem;
                    padding: 0 20px;
                    background: rgb(233, 233, 235);
                    color: #606266;
                    margin-bottom: 5px;
                }
                .warning_msg {
                    background-color: #E6A23C;
                    color: #fff;
                }
                .compare_box {
                    .right_text {
                        padding-left: 20px;
                    }
                }

                .unite_msg {
                    padding-left: 20px;
                    font-size: .75rem;
                    color: #F56C6C;
                }

                .unite_item {
                    border: 1px solid #ccc;
                    border-radius: 5px;
                    margin-bottom: 5px;
                    padding: 5px;
                    box-sizing: border-box;
                    position: relative;
                    .unite_title {
                        font-weight: 600;
                        font-size: .75rem;
                    }
                    .table_del_btn {
                        position: absolute;
                        top: 0;
                        right: 10px;
                        padding: 5px 20px;
                        z-index: 10;
                    }
                }
            }
            .line {
                width: 1px;
                height: 100%;
                background: #ccc;
            }
            .image_form {
                flex: 2;
                height: 100%;
                overflow: hidden;
                overflow-y: auto;
                padding: 0 5px;
                box-sizing: border-box;
                display: flex;
                flex-flow: column;
                .msg_title {
                    line-height: 35px;
                    font-size: .875rem;
                    padding: 0 20px;
                    background: rgb(233, 233, 235);
                    color: #606266;
                    margin-bottom: 5px;
                }
                .img_box {
                    flex: 1;
                    width: 100%;
                    height: calc(100% - 40px);
                }

            }
        }

    }
</style>